import React, { Component, Fragment } from "react";
import ContentEditable from "react-contenteditable";
import './counter.scss'
class Counter extends Component {
  constructor(props) {
    super(props);
    this.contentEditable = React.createRef();
  }
  render() {
    let style = this.props.vidStyle;

    return (
      <div
        className={`${this.props.disabled === true ? "disabledCounter" : ""}`}
      >
        <label>
          {this.props.label ? (
            <Fragment>
              {this.props.label}
              <small> {this.props.small == "percent" ? "%" : "px"} </small>
            </Fragment>
          ) : null}
        </label>
        <div className="counter">
          <button
            type="button"
            className="counterMinus"
            disabled={this.props.disabled === true}
            onClick={this.props.minusClick}
            value={this.props.valueContent}
          >
            <svg
              width="12"
              height="2"
              viewBox="0 0 12 2"
            >
              <rect
                id="Rectangle_11_copy_3"
                data-name="Rectangle 11 copy 3"
                width="12"
                height="2"
                fill="rgba(12,50,84,0.6)"
              />
            </svg>
          </button>

          <div className="changeWrapper">
            <input
              type="number"
              value={this.props.valueContent}
              onChange={this.props.onChange}
              disabled={this.props.disabled === true}
              onKeyPress={(e) => {
                e.key === "Enter" && e.preventDefault();
              }}
            />
          </div>
          <button
            type="button"
            className="counterPlus"
            disabled={this.props.disabled === true}
            onClick={this.props.plusClick}
            value={this.props.valueContent}
          >
            <svg
              width="12.002"
              height="12"
              viewBox="0 0 12.002 12"
            >
              <path
                id="Union_14"
                data-name="Union 14"
                d="M5,12V7H0V5H5V0H7V5h5V7H7v5Z"
                transform="translate(0 0)"
                fill="rgba(12,50,84,0.6)"
              />
            </svg>
          </button>
        </div>
      </div>
    );
  }
}
export default Counter;
